

/**
 * get root name
 */
export function getRootName() {
  return 'main'
}

// vi: se ts=2 sw=2 et:
